export const generalContent = {
    registryName: "SODA Registry",
    registryTagLine: "Registry For Sustainable Outcomes",
    primaryAsset: "SODA",
    registryOwner: "Sustainable Outcome Digital Assets"
};